module.exports = __webpack_public_path__ + "img/cr1_2.ba4f15f9.png";